// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { Cross } from '../../../../assets/svg/common';

const Svg = styled(Cross)`
  bottom: 0;
  right: 0;
  z-index: 1;
  width: 1.6em;
  height: auto;
  fill: #fff;
  margin: 0.6em 1em 0.6em;
`;

type Props = {
  className?: string;
  onClick: () => void;
};

const CrossCloseButton = ({ className, onClick }: Props) => {
  return <Svg className={className} onClick={onClick} title="close" />;
};

export default CrossCloseButton;
